import { userLogApi } from '../api';

export const userLogRepo = {
    getAll: (params) => userLogApi.getAll(params),
    getStats: (params) => userLogApi.getStats(params),
    getByUser: (username, params) => userLogApi.getByUser(username, params),
    getById: (userlogId) => userLogApi.getById(userlogId),
};